import {EmployeeLeaveList} from "./EmployeeLeaveList";
import {EmployeeLeaveEdit} from "./EmployeeLeaveEdit";


export default {
    list: EmployeeLeaveList,
    edit: EmployeeLeaveEdit
};
